module.exports = __webpack_public_path__ + "static/media/redemptionsHeader.48b8fdfe.svg";